<template>
	<div class="content-wrap">


	</div>

</template>
<script>

import VueCookies from 'vue-cookies'
export default {
  name: 'redirect',
  mounted(){
    var path = this.$route.path;
    var language = path.split('/')[1];
    if (language == 'kr') language = 'ko';
      else if (language == 'cn') language = 'cn';
      else if (language == 'jp') language = 'ja'
    this.$store.commit('setLanguage',language);
    if (path != '/cn') {
      this.$router.push('/');
    } else if(location.host != 'rc.todomath.com' && location.host != 'localhost:1024'){
      this.$router.push('/?l=cn')
    } else {
      location.replace('https://sv.todomath.com/sv/download')
    }
  },
  data () {
    return {

    }
	}
}
</script>
<style  scoped>
.content-wrap{
	position: relative;
	min-width:100%;
}



</style>



// WEBPACK FOOTER //
// src/pages/Redirect.vue